import React from 'react'
import IconBase from '../IconBase'

const svgContent = <svg viewBox="0 0 1024 1024" width="1em" height="1em" focusable="false" fill="currentColor" aria-hidden="true"><path d="M11.253 506.374a506.374 506.374 0 1 0 1012.747 0 506.374 506.374 0 1 0-1012.747 0Z" fill="#5153E0" /><path d="M360.088 472.615h315.077q33.758 0 33.758 33.759 0 33.758-33.758 33.758H360.088q-33.758 0-33.758-33.758 0-33.759 33.758-33.759Z" fill="#FFF" /><path d="M551.385 348.835v315.077a33.758 33.758 0 0 1-67.517 0V348.835a33.758 33.758 0 0 1 67.517 0z" fill="#FFF" /></svg>

const AddCircle = React.forwardRef((props, ref) => {
  return (
    <IconBase name="add-circle" {...props} ref={ref}>
      {svgContent}
    </IconBase>
  )
})

AddCircle.displayName = 'IconAddCircle'

export default AddCircle
